import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "../Sidebar/Sidebar.css";
import environment from "../../environment/environment";

const Sidebar = () => {
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [tripTypeDetails, setTripTypeDetails] = useState({
        internationalList: [],
        domesticList: [],
        weekendList: [],
        groupList: [],
        honeymoonList: []
    });

    useEffect(() => {
        getAllTripType();
    }, []);

    const toggleDropdown = (index) => {
        setActiveDropdown(activeDropdown === index ? null : index);
    };
    
    const getAllTripType = () => {
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllTripType`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setTripTypeDetails(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching trip types:", err);
            });
    };
    const organizeRoutesByName = (routeList) => {
        if (!routeList || routeList.length === 0) return [[], [], []];
        const uniqueRoutes = [];
        const seenNames = new Set();

        routeList.forEach(route => {
            if (!seenNames.has(route.routeName)) {
                seenNames.add(route.routeName);
                uniqueRoutes.push({
                    name: route.routeName,
                    id: route.routeId
                });
            }
        });
        const columns = [[], [], []];
        uniqueRoutes.forEach((route, index) => {
            columns[index % 3].push(route);
        });

        return columns;
    };
    const items = [
        {
            label: "International Packages",
            options: tripTypeDetails.internationalList?.length > 0
                ? organizeRoutesByName(tripTypeDetails.internationalList)
                : [[{ name: "No packages available", id: null }]],
        },
        {
            label: "Domestic Packages",
            options: tripTypeDetails.domesticList?.length > 0
                ? organizeRoutesByName(tripTypeDetails.domesticList)
                : [[{ name: "No packages available", id: null }]],
        },
        {
            label: "Weekend Trips",
            options: tripTypeDetails.weekendList?.length > 0
                ? organizeRoutesByName(tripTypeDetails.weekendList)
                : [[{ name: "No packages available", id: null }]],
        },
        {
            label: "Group Trips",
            options: tripTypeDetails.groupList?.length > 0
                ? organizeRoutesByName(tripTypeDetails.groupList)
                : [[{ name: "No packages available", id: null }]],
        },
        {
            label: "Honeymoon Packages",
            options: tripTypeDetails.honeymoonList?.length > 0
                ? organizeRoutesByName(tripTypeDetails.honeymoonList)
                : [[{ name: "No packages available", id: null }]],
        },
    ];
    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            'div',
            {
                className: "offcanvas offcanvas-end d-md-none",
                tabIndex: "-1",
                id: "mobileSidebar",
                'aria-labelledby': "mobileSidebarLabel"
            },
            React.createElement(
                'div',
                { className: "offcanvas-header" },
                React.createElement('h5', { className: "offcanvas-title", id: "mobileSidebarLabel" }, "Menu"),
                React.createElement(
                    'button',
                    {
                        type: "button",
                        className: "btn-close",
                        'data-bs-dismiss': "offcanvas",
                        'aria-label': "Close",
                        style: {
                            backgroundColor: "#fff099",
                            color: "white",
                            borderRadius:'50%'
                        }
                    }
                )
            ),
            React.createElement(
                'div',
                { className: "offcanvas-body" },
                React.createElement(
                    'ul',
                    { className: "list-unstyled" },
                    items.map((item, index) => {
                        return React.createElement(
                            'li',
                            { key: index },
                            React.createElement(
                                'button',
                                {
                                    className: "btn w-100 text-start mb-1 sidebar-dropdown-toggle",
                                    onClick: () => toggleDropdown(index)
                                },
                                item.label,
                                React.createElement(
                                    'span',
                                    { className: "float-end" },
                                    React.createElement('i', {
                                        className: `bi ${activeDropdown === index ? "bi-chevron-up" : "bi-chevron-down"}`
                                    })
                                )
                            ),
                            activeDropdown === index && React.createElement(
                                'div',
                                { className: "dropdown-menu show position-static" },
                                React.createElement(
                                    'div',
                                    { className: "d-flex flex-wrap" },
                                    item.options.map((col, colIndex) => {
                                        return React.createElement(
                                            'div',
                                            { key: colIndex, className: "me-4" },
                                            col.map((route, optIndex) => {
                                                return React.createElement(
                                                    Link,
                                                    {
                                                        key: optIndex,
                                                        to: `/tour/${route.id}`,
                                                        className: "dropdown-item",
                                                        style: { color: "black", textDecoration: "none" },
                                                        target: "_blank"
                                                    },
                                                    route.name
                                                );
                                            })
                                        );
                                    })
                                )
                            )
                        );
                    })
                )
            )
        )
    );
};

export default Sidebar;